// src/data/roleDashboard.js

export const ROLES = [
  {
    id: "full-stack",
    title: "Full Stack Developer",
    shortTitle: "Full Stack",
    description:
      "End-to-end web applications — from polished UIs to scalable APIs and databases.",
    tech: [
      "HTML",
      "CSS",
      "JavaScript",
      "React.js",
      "React Native",
      "Node.js",
      "Express.js",
      "MongoDB",
      "MySQL",
      "Firebase",
      "REST APIs",
      "Socket.IO",
      "JWT",
      "Testing & Deployment",
      "Cloud Services",
      "Debugging & Optimization",
      "Problem Solving",
      "CI/CD",
      "Version Control",
      "Frontend & Backend Architecture",
    ],
    route: "/role/full-stack",
    accent: {
      text: "text-indigo-500",
      bg: "bg-indigo-500/10",
      border: "border-indigo-500/30",
      dot: "bg-indigo-500",
    },
    icon: "Layers",
  },
  {
    id: "react-native",
    title: "React Native Developer",
    shortTitle: "React Native",
    description:
      "Cross-platform mobile apps with smooth native-grade interactions.",
    tech: [
      "React Native",
      "Expo",
      "Redux",
      "Firebase",
      "REST APIs",
      "Socket.IO",
      "JWT",
      "CLI",
      "CSS",
    ],
    route: "/role/react-native",
    accent: {
      text: "text-cyan-500",
      bg: "bg-cyan-500/10",
      border: "border-cyan-500/30",
      dot: "bg-cyan-500",
    },
    icon: "Smartphone",
  },
  {
    id: "backend",
    title: "Backend Developer",
    shortTitle: "Backend",
    description:
      "Robust server-side systems, REST APIs, authentication, and database design.",
    tech: [
      "Node.js",
      "Express",
      "MongoDB",
      "JWT",
      "Socket.IO",
      "REST APIs",
      "MySQL",
      "Java",
      "Authentication",
      "Real-time Communication",
      "Validation & Error Handling",
      "Application Logic",
      "Testing & Deployment",
      "Cloud Services",
      "Debugging & Optimization",
      "Problem Solving",
      "CI/CD",
      "Version Control",
      "Backend Architecture",
      "Server-side Engineering",
      "Database Design",
      "API Development",
      "Security Best Practices",
      "Performance Optimization",
      "Scalability & Load Balancing",
      "Caching Strategies",
    ],
    route: "/role/backend",
    accent: {
      text: "text-emerald-500",
      bg: "bg-emerald-500/10",
      border: "border-emerald-500/30",
      dot: "bg-emerald-500",
    },
    icon: "Server",
  },
  {
    id: "java",
    title: "Java Developer",
    shortTitle: "Java",
    description:
      "Object-oriented backend services, Spring Boot APIs, and enterprise-grade logic.",
    tech: [
      "Java",
      "MySQL",
      "REST",
      "APIs",
      "OOP",
      "DSA",
      "Authentication",
      "Real-time Communication",
      "Validation & Error Handling",
      "Application Logic",
      "Testing & Deployment",
      "Cloud Services",
      "Debugging & Optimization",
      "Problem Solving",
      "CI/CD",
      "Version Control",
      "Backend Architecture",
      "Server-side Engineering",
      "Database Design",
      "API Development",
      "Security Best Practices",
      "Performance Optimization",
      "Scalability & Load Balancing",
    ],
    route: "/role/java",
    accent: {
      text: "text-orange-500",
      bg: "bg-orange-500/10",
      border: "border-orange-500/30",
      dot: "bg-orange-500",
    },
    icon: "Coffee",
  },
  {
    id: "software-engineer",
    title: "Software Engineer (SDE)",
    shortTitle: "SDE",
    description:
      "Problem solving, data structures, algorithms, and scalable software design.",
    tech: [
      "DSA",
      "System Design",
      "OOP",
      "Databases",
      "REST APIs",
      "Authentication",
      "Real-time Communication",
      "Validation & Error Handling",
      "Application Logic",
      "Testing & Deployment",
      "Cloud Services",
      "Debugging & Optimization",
      "Problem Solving",
      "CI/CD",
      "Version Control",
      "Backend Architecture",
      "Server-side Engineering",
      "Database Design",
      "API Development",
      "Security Best Practices",
      "Performance Optimization",
      "Scalability & Load Balancing",
    ],
    route: "/role/software-engineer",
    accent: {
      text: "text-violet-500",
      bg: "bg-violet-500/10",
      border: "border-violet-500/30",
      dot: "bg-violet-500",
    },
    icon: "Code2",
  },
];

export const DASHBOARD_NAV = [
  {
    id: "overview",
    label: "Overview",
    icon: "LayoutDashboard",
    path: "/role-dashboard",
    ready: true,
  },
  {
    id: "leetcode",
    label: "LeetCode Profile",
    icon: "Code2",
    path: "",
    ready: true,
  },
  {
    id: "resume",
    label: "Resumes",
    icon: "FileText",
    path: "",
    ready: true,
  },
  {
    id: "roles",
    label: "Role Profiles",
    icon: "Users",
    path: "/role-dashboard/roles",
    ready: false,
  },
  {
    id: "projects",
    label: "Projects",
    icon: "FolderKanban",
    path: "/role-dashboard/projects",
    ready: false,
  },
  {
    id: "skills",
    label: "Skills & Technologies",
    icon: "Cpu",
    path: "/role-dashboard/skills",
    ready: false,
  },
  {
    id: "experience",
    label: "Experience & Education",
    icon: "Briefcase",
    path: "/role-dashboard/experience",
    ready: false,
  },

  {
    id: "share",
    label: "Share Profile & Contact",
    icon: "Share2",
    path: "/role-dashboard/contact",
    ready: false,
  },
];

// Featured project picks — swap these to actual project IDs from your existing projects data
export const FEATURED_PROJECTS = [
  "foodmitra",
  "vehicle-service",
  "parkeasy",
  "scalegate",
];

// inside src/data/roleDashboard.js
